import { render, staticRenderFns } from "./complain-detail.vue?vue&type=template&id=a1d8d65e&scoped=true&"
import script from "./complain-detail.vue?vue&type=script&lang=js&"
export * from "./complain-detail.vue?vue&type=script&lang=js&"
import style0 from "./complain-detail.vue?vue&type=style&index=0&id=a1d8d65e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d8d65e",
  null
  
)

export default component.exports